import { Component, Host, Prop, h } from '@stencil/core'
import type { CoreIcon } from '@pollux-docaposte/core-design-system'

@Component({
  tag: 'cobalt-icon',
  styleUrl: 'cobalt-icon.css',
  assetsDirs: ['assets']
})
export class CobaltIcon {
  /**
   * Accept all icon names from `@pollux-docaposte/icon-library`.
   * By using the `cobalt-icon` component you don't have to install it as dependency. It is **required**.
   */
  @Prop({ mutable: true }) name!: CoreIcon['name']
  /**
   * Taking the currentcolor (inherited color of the font) by default, except if specified.
   */
  @Prop({ mutable: true }) fill?: CoreIcon['fill'] = 'currentcolor'
  /**
   * Taking the size of the parent element by default, except if specified.
   */
  @Prop({ mutable: true }) size?: CoreIcon['size']

  render(): any {
    return (
      <Host>
        <core-icon name={this.name} size={this.size} fill={this.fill}></core-icon>
      </Host>
    )
  }
}
